import { render, staticRenderFns } from "./Zrsdqtx.vue?vue&type=template&id=b0051ef8&scoped=true&"
import script from "./Zrsdqtx.vue?vue&type=script&lang=js&"
export * from "./Zrsdqtx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0051ef8",
  null
  
)

export default component.exports